import { ScheduleDatesSchema } from '../../CampaignComponents/components/ScheduleDates/schemas/schedule-dates.schema';
import { GeneralSurveyConfigureFormValues } from '../components/ConfigureForm/types';
import { configureFormSchema } from '../components/ConfigureForm/validation';
import { GeneralSurveyScheduleFormValues } from '../components/ScheduleForm/types';
import { GeneralSurveyTargetFormValues } from '../components/TargetForm/types';
import { targetFormSchema } from '../components/TargetForm/validation';

export const isConfigureFormValuesValid = (
  values?: Partial<GeneralSurveyConfigureFormValues> | null,
): values is GeneralSurveyConfigureFormValues => {
  return configureFormSchema.safeParse(values).success;
};

export const isTargetFormValuesValid = (
  values?: Partial<GeneralSurveyTargetFormValues> | null,
): values is GeneralSurveyTargetFormValues => {
  return targetFormSchema.safeParse(values).success;
};

export const isScheduleFormValuesValid = (
  values?: Partial<GeneralSurveyScheduleFormValues> | null,
): values is GeneralSurveyScheduleFormValues => {
  return ScheduleDatesSchema.safeParse(values).success;
};
